import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { i as img$2, C as CardAltSmall } from './cardAltSmall.component-f7a0ae0b.js';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import './post.actions-dcd472e5.js';
import { DgPicture } from 'dg-utils';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { reduxForm, Field } from 'redux-form';
import { dgSelect } from 'dg-forms';

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Card = /*#__PURE__*/function (_Component) {
  _inherits(Card, _Component);

  var _super = _createSuper$d(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    _this = _super.call(this, props);
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    _this.truncateSummary = _this.truncateSummary.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Card, [{
    key: "onSelect",
    value: function onSelect(post) {
      window.scrollTo(0, 0);
    }
  }, {
    key: "truncateSummary",
    value: function truncateSummary(text) {
      var maxNumWords = this.props.truncateNumWords || 20;
      var summary = text || '';
      var numOfWordsInSummary = summary.split(' ');

      if (numOfWordsInSummary.length >= maxNumWords) {
        numOfWordsInSummary = numOfWordsInSummary.slice(0, maxNumWords);
        return "".concat(numOfWordsInSummary.join(' '), " ...");
      }

      return summary;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: this.props.cardClass ? "blog-card ".concat(this.props.cardClass) : 'blog-card'
      }, /*#__PURE__*/React.createElement(Link, {
        to: "".concat(this.props.urlPrefix ? this.props.urlPrefix : '/blog/post', "/").concat(this.props.post.slug || this.props.post._id),
        className: "blog-link-wrapper",
        onClick: function onClick() {
          return _this2.onSelect(_this2.props.post);
        }
      }, /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== '' ? this.props.post.header_image : img$2,
        alt: "post header img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("h4", null, this.props.post.title), /*#__PURE__*/React.createElement("p", null, this.props.truncateNumWords ? this.truncateSummary(this.props.post.summary) : this.props.post.summary)), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("h5", null, new Date(this.props.post.createdAt).toLocaleDateString('en-uk', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }))), this.props.post && this.props.post.tag && this.props.post.tag != '' ? /*#__PURE__*/React.createElement("div", {
        className: "item text-right"
      }, /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.post.tag)) : ''))));
    }
  }]);

  return Card;
}(Component);

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CardAlt = /*#__PURE__*/function (_Component) {
  _inherits(CardAlt, _Component);

  var _super = _createSuper$c(CardAlt);

  function CardAlt(props) {
    var _this;

    _classCallCheck(this, CardAlt);

    _this = _super.call(this, props);
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardAlt, [{
    key: "onSelect",
    value: function onSelect(post) {
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: this.props.cardClass ? "blog-card ".concat(this.props.cardClass) : 'blog-card'
      }, /*#__PURE__*/React.createElement(Link, {
        to: "".concat(this.props.urlPrefix ? this.props.urlPrefix : '/blog/post', "/").concat(this.props.post.slug || this.props.post._id),
        className: "blog-link-wrapper",
        onClick: function onClick() {
          return _this2.onSelect(_this2.props.post);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== '' ? this.props.post.header_image : img$2,
        alt: "post header img"
      }), this.props.imageTint ? /*#__PURE__*/React.createElement("div", {
        className: this.props.imageTint
      }) : '', /*#__PURE__*/React.createElement("h4", null, this.props.post.title), this.props.showDate ? /*#__PURE__*/React.createElement("h5", null, new Date(this.props.post.createdAt).toLocaleDateString('en-uk', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })) : ''), this.props.showSummary ? /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("p", null, this.props.post.summary), /*#__PURE__*/React.createElement("h3", null, this.props.linkText ? this.props.linkText : '')) : '', this.props.showTags ? /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, this.props.post && this.props.post.tag && this.props.post.tag != '' ? /*#__PURE__*/React.createElement("div", {
        className: "item text-right"
      }, /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.post.tag)) : '') : ''));
    }
  }]);

  return CardAlt;
}(Component);

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CardHorizontal$1 = /*#__PURE__*/function (_Component) {
  _inherits(CardHorizontal, _Component);

  var _super = _createSuper$b(CardHorizontal);

  function CardHorizontal(props) {
    var _this;

    _classCallCheck(this, CardHorizontal);

    _this = _super.call(this, props);
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardHorizontal, [{
    key: "onSelect",
    value: function onSelect(post) {
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: this.props.cardClass ? "blog-card-vertical ".concat(this.props.cardClass) : "blog-card-vertical"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "".concat(this.props.urlPrefix ? this.props.urlPrefix : '/blog/post', "/").concat(this.props.post.slug || this.props.post._id),
        className: "blog-link-wrapper",
        onClick: function onClick() {
          return _this2.onSelect(_this2.props.post);
        }
      }, /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== '' ? this.props.post.header_image : img$2,
        alt: "post header img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("h4", null, this.props.post.title), /*#__PURE__*/React.createElement("p", null, this.props.post.summary), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "redux-blogs-btn-primary",
        onClick: function onClick() {
          return _this2.props.onSelect(_this2.props.post);
        }
      }, "Read More")), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, this.props.post && this.props.post.tag && this.props.post.tag != '' ? /*#__PURE__*/React.createElement("div", {
        className: "item text-right"
      }, /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.post.tag)) : '', /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("h5", null, new Date(this.props.post.createdAt).toLocaleDateString('en-uk', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }))))))));
    }
  }]);

  return CardHorizontal;
}(Component);

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CardHorizontal = /*#__PURE__*/function (_Component) {
  _inherits(CardHorizontal, _Component);

  var _super = _createSuper$a(CardHorizontal);

  function CardHorizontal(props) {
    var _this;

    _classCallCheck(this, CardHorizontal);

    _this = _super.call(this, props);
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardHorizontal, [{
    key: "onSelect",
    value: function onSelect(post) {
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: this.props.cardClass ? "blog-card ".concat(this.props.cardClass) : 'blog-card'
      }, /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement(Link, {
        to: "".concat(this.props.urlPrefix ? this.props.urlPrefix : '/blog/post', "/").concat(this.props.post.slug || this.props.post._id),
        className: "blog-link-wrapper",
        onClick: function onClick() {
          return _this2.onSelect(_this2.props.post);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-container"
      }, /*#__PURE__*/React.createElement(DgPicture, {
        className: this.props.imageContainerClass ? this.props.imageContainerClass : ''
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== '' ? this.props.post.header_image : img$2,
        alt: "post header img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "overlay"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "body-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "wrapper"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "date"
      }, new Date(this.props.post.createdAt).toLocaleDateString('en-uk', {
        month: 'long',
        day: 'numeric'
      })), /*#__PURE__*/React.createElement("h4", null, this.props.post.title), /*#__PURE__*/React.createElement(Link, {
        to: "".concat(this.props.urlPrefix ? this.props.urlPrefix : '/blog/post', "/").concat(this.props.post._id),
        className: "blog-link-wrapper"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn-primary",
        onClick: function onClick() {
          return _this2.props.onSelect(_this2.props.post);
        }
      }, "Read Blog Post"))))));
    }
  }]);

  return CardHorizontal;
}(Component);

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FeaturedPost = /*#__PURE__*/function (_Component) {
  _inherits(FeaturedPost, _Component);

  var _super = _createSuper$9(FeaturedPost);

  function FeaturedPost() {
    _classCallCheck(this, FeaturedPost);

    return _super.apply(this, arguments);
  }

  _createClass(FeaturedPost, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: this.props.cardClass ? "feature-post ".concat(this.props.cardClass) : "feature-post"
      }, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== '' ? this.props.post.header_image : img$2,
        alt: "Feature Img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tag-date-info"
      }, this.props.post && this.props.post.tag && this.props.post.tag != '' ? /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.post.tag)) : '', this.props.post && this.props.post.createdAt ? /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("h6", null, new Date(this.props.post.createdAt).toLocaleDateString('en-uk', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }))) : ''), this.props.post && this.props.post.title ? /*#__PURE__*/React.createElement("h2", {
        className: "text-capitalize"
      }, this.props.post.title) : '', /*#__PURE__*/React.createElement("p", null, this.props.post && this.props.post.summary ? this.props.post.summary : ''), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "redux-blogs-btn-primary",
        onClick: function onClick() {
          return _this.props.onSelect(_this.props.post);
        }
      }, "Read More"))));
    }
  }]);

  return FeaturedPost;
}(Component);

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CardAlt2 = /*#__PURE__*/function (_Component) {
  _inherits(CardAlt2, _Component);

  var _super = _createSuper$8(CardAlt2);

  function CardAlt2(props) {
    var _this;

    _classCallCheck(this, CardAlt2);

    _this = _super.call(this, props);
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardAlt2, [{
    key: "onSelect",
    value: function onSelect(post) {
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: this.props.cardClass ? "blog-card ".concat(this.props.cardClass) : "blog-card"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "".concat(this.props.urlPrefix ? this.props.urlPrefix : "/blog/post", "/").concat(this.props.post.slug || this.props.post._id),
        className: "blog-link-wrapper",
        onClick: function onClick() {
          return _this2.onSelect(_this2.props.post);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-image"
      }, this.props.post && this.props.post.header_image && /*#__PURE__*/React.createElement("img", {
        src: this.props.post.header_image,
        alt: this.props.post.title
      })), /*#__PURE__*/React.createElement("div", {
        className: "card-content"
      }, this.props.post && this.props.post.createdAt && /*#__PURE__*/React.createElement("p", {
        className: "blog-date"
      }, new Date(this.props.post.createdAt).toLocaleDateString("en-GB")), this.props.post && this.props.post.title && /*#__PURE__*/React.createElement("h3", null, this.props.post.title), this.props.post && this.props.post.summary && /*#__PURE__*/React.createElement("p", null, this.props.post.summary)))));
    }
  }]);

  return CardAlt2;
}(Component);

var CardCoverInAClick = function CardCoverInAClick(_ref) {
  _ref.style;
      _ref.cardClass;
      _ref.urlPrefix;
      var post = _ref.post,
      onSelect = _ref.onSelect;
  var dateString = new Date(post.createdAt).toLocaleDateString('en-uk', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "round-blog-card-container"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "date"
  }, dateString), /*#__PURE__*/React.createElement(DgPicture, null, /*#__PURE__*/React.createElement("img", {
    onClick: function onClick() {
      return onSelect(post);
    },
    src: post !== null && post !== void 0 && post.header_image ? post.header_image : img$2,
    alt: 'Blog post header image'
  })), /*#__PURE__*/React.createElement("h3", null, post.title), /*#__PURE__*/React.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onSelect(post);
    }
  }, "Read More")));
};

var exports = undefined;

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Components
// Assets

var Container = /*#__PURE__*/function (_Component) {
  _inherits(Container, _Component);

  var _super = _createSuper$7(Container);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    _this = _super.call(this, props);
    _this.state = {
      isMobileSite: false
    };
    _this.isMobileSite = _this.isMobileSite.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Container, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMobileSite();
      window.addEventListener("resize", this.isMobileSite);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.isMobileSite);
    }
  }, {
    key: "isMobileSite",
    value: function isMobileSite() {
      var tmp = window.innerWidth > 1025; // Use innerWidth over availWidth for orientation on mobile devices

      if (this.state.isMobileSite !== tmp) {
        this.setState({
          isMobileSite: tmp
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      /* 
          Types: 
              "no-padding": padding set to 0 on both sides,
              "no-padding-left": padding set to 0 on left side,
              "no-padding-right": padding set to 0 on right side,
              "reverse": "row-reverse"
      */
      return /*#__PURE__*/React.createElement("div", {
        className: "dg-blocks-container dg-blocks-clamp ".concat(this.props["class"], " ").concat(!this.state.isMobileSite && this.props.mobileType ? this.props.mobileType : this.props.type ? this.props.type : ''),
        style: this.props.style ? this.props.style : {}
      }, // Debug option
      this.props.debug ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("h1", null, "isMobileSite :: ", !this.state.isMobileSite && this.props.mobileType ? 'Mobile' : 'Desktop'), /*#__PURE__*/React.createElement("h2", null, "exports.desktop :: ", exports.desktop)) : '', this.props.children);
    }
  }]);

  return Container;
}(Component);

var Container$1 = connect(null, {})(Container);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Components
// Assets

var DynamicCol = /*#__PURE__*/function (_Component) {
  _inherits(DynamicCol, _Component);

  var _super = _createSuper$6(DynamicCol);

  function DynamicCol() {
    _classCallCheck(this, DynamicCol);

    return _super.apply(this, arguments);
  }

  _createClass(DynamicCol, [{
    key: "render",
    value: function render() {
      var cols = [];
      var errors = [];
      var width = undefined;

      if (this.props.numCols) {
        for (var index = 0; index < this.props.numCols; index++) {
          var _this$props;

          var colNumber = index + 1; // Check if size is specified

          if (this.props["col".concat(colNumber, "Size")]) {
            // Initialise Width
            if (width === undefined) {
              width = 0;
            }

            width += parseInt(this.props["col".concat(colNumber, "Size")]);
          }

          cols.push( /*#__PURE__*/React.createElement("div", {
            key: "dynamic_col_".concat(index),
            className: "col ".concat(this.props["col".concat(colNumber, "Size")] ? "col-".concat(parseInt(this.props["col".concat(colNumber, "Size")])) : "", " ").concat(((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.className) || ""),
            style: this.props.style ? this.props.style : {}
          }, this.props["col".concat(colNumber)] ? this.props["col".concat(colNumber)] : ""));
        } // ---- Error Checking ----


        if (width) {
          for (var _index = 0; _index < this.props.numCols; _index++) {
            var _colNumber = _index + 1; // If size is specified, all col sizes must then be specified.


            if (this.props["col".concat(_colNumber, "Size")] === undefined) {
              errors.push( /*#__PURE__*/React.createElement("li", null, "Error :: Once a Col size is specified, all col sizes must be set. (This is to ensure large pieces of content don't cause cols to grow to full width.)", " "));
            }
          } // All width's must add to 100%


          if (width > 100) {
            errors.push( /*#__PURE__*/React.createElement("li", null, "Error :: Width(", width, "%) should not be > 100% in a row."));
          }
        }
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, // If error's exist, show them, otherwise show the content.
      errors.length > 0 ? /*#__PURE__*/React.createElement("ul", null, errors) : cols);
    }
  }]);

  return DynamicCol;
}(Component);

var DynamicCol$1 = connect(null, {})(DynamicCol);

var Left = function Left(_ref) {
  var image = _ref.image,
      imageMobile = _ref.imageMobile,
      alt = _ref.alt;
  return /*#__PURE__*/React.createElement("div", {
    className: "left-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(DgPicture, null, imageMobile && /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 1025px)",
    srcSet: imageMobile,
    type: "image/png"
  }), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: alt
  }))));
};

var Right = function Right(_ref2) {
  var children = _ref2.children,
      type = _ref2.type;
  return /*#__PURE__*/React.createElement("div", {
    className: "right-container ".concat(type)
  }, /*#__PURE__*/React.createElement("div", {
    className: "overlap-content-container"
  }, children));
};

var Column = function Column(_ref3) {
  var children = _ref3.children,
      type = _ref3.type,
      _ref3$content = _ref3.content,
      image = _ref3$content.image,
      imageMobile = _ref3$content.imageMobile,
      alt = _ref3$content.alt;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Left, {
    image: image,
    mobileImage: imageMobile,
    alt: alt
  }), /*#__PURE__*/React.createElement(Right, {
    type: type
  }, children));
};

var OverlapBlock = function OverlapBlock(_ref4) {
  var children = _ref4.children,
      content = _ref4.content,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? "" : _ref4$type;
  return /*#__PURE__*/React.createElement(Container$1, {
    "class": "overlap-block",
    type: "no-padding"
  }, /*#__PURE__*/React.createElement(DynamicCol$1, {
    numCols: 1,
    col1: /*#__PURE__*/React.createElement(Column, {
      content: content,
      type: type,
      children: children
    }),
    className: type
  }));
};

var Pill = function Pill(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "FITNESS" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: "pill ".concat(type),
    onClick: onClick
  }, label);
};

var Button = function Button(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "CONTACT US" : _ref$label,
      linkTo = _ref.linkTo,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      onClick = _ref.onClick;
  return linkTo ? /*#__PURE__*/React.createElement("a", {
    className: "btn-primary ".concat(type),
    href: linkTo,
    onClick: onClick
  }, label) : /*#__PURE__*/React.createElement("button", {
    className: "btn-primary ".concat(type),
    onClick: onClick
  }, label);
};

var BlogCard = function BlogCard(_ref) {
  var style = _ref.style,
      cardClass = _ref.cardClass,
      onSelect = _ref.onSelect,
      _ref$post = _ref.post,
      title = _ref$post.title,
      summary = _ref$post.summary,
      header_image = _ref$post.header_image,
      tags = _ref$post.tags,
      createdAt = _ref$post.createdAt,
      post = _ref.post;
  var dateString = new Date(createdAt).toLocaleDateString("en-uk", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
  var content = {
    image: header_image,
    alt: "blog header image"
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style ? style : {},
    className: "glass-card-container ".concat(cardClass)
  }, /*#__PURE__*/React.createElement(OverlapBlock, {
    content: content
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-container"
  }, /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("h5", null, dateString)), /*#__PURE__*/React.createElement("div", {
    className: "middle-container"
  }, /*#__PURE__*/React.createElement("p", null, summary), /*#__PURE__*/React.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "SEE MORE",
    onClick: function onClick() {
      return onSelect(post);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "bottom-container"
  }, tags.map(function (tag, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pill-container"
    }, /*#__PURE__*/React.createElement(Pill, {
      label: tag,
      key: "tag-".concat(idx)
    }));
  })))));
};

var img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' sodipodi:docname='left-carrot.svg' inkscape:version='1.0 (4035a4fb49%2c 2020-05-01)' id='svg1494' version='1.1' viewBox='0 0 1.8350092 3.1887493' height='3.1887493mm' width='1.8350092mm'%3e %3cdefs id='defs1488' /%3e %3csodipodi:namedview inkscape:window-maximized='0' inkscape:window-y='0' inkscape:window-x='76' inkscape:window-height='728' inkscape:window-width='1274' showgrid='false' inkscape:document-rotation='0' inkscape:current-layer='layer1' inkscape:document-units='mm' inkscape:cy='28.883135' inkscape:cx='46.324876' inkscape:zoom='0.35' inkscape:pageshadow='2' inkscape:pageopacity='0.0' borderopacity='1.0' bordercolor='%23666666' pagecolor='white' id='base' /%3e %3cmetadata id='metadata1491'%3e %3crdf:RDF%3e %3ccc:Work rdf:about=''%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3e %3cdc:title%3e%3c/dc:title%3e %3c/cc:Work%3e %3c/rdf:RDF%3e %3c/metadata%3e %3cg transform='translate(-93.576543%2c-140.52467)' id='layer1' inkscape:groupmode='layer' inkscape:label='Layer 1'%3e %3cpath d='m 95.286452%2c140.64902 -1.461205%2c1.47003 1.461205%2c1.47002' style='fill:none%3bstroke:white%3bstroke-width:0.352777%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-miterlimit:10%3bstroke-dasharray:none%3bstroke-opacity:1' id='path624' /%3e %3c/g%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' inkscape:version='1.0 (4035a4fb49%2c 2020-05-01)' sodipodi:docname='right-carrot.svg' id='svg1494' version='1.1' viewBox='0 0 1.8350041 3.1887488' height='3.1887488mm' width='1.8350041mm'%3e %3cdefs id='defs1488' /%3e %3csodipodi:namedview inkscape:window-maximized='0' inkscape:window-y='0' inkscape:window-x='76' inkscape:window-height='728' inkscape:window-width='1274' showgrid='false' inkscape:document-rotation='0' inkscape:current-layer='layer1' inkscape:document-units='mm' inkscape:cy='-196.51946' inkscape:cx='-373.06454' inkscape:zoom='0.35' inkscape:pageshadow='2' inkscape:pageopacity='0.0' borderopacity='1.0' bordercolor='%23666666' pagecolor='white' id='base' /%3e %3cmetadata id='metadata1491'%3e %3crdf:RDF%3e %3ccc:Work rdf:about=''%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3e %3cdc:title%3e%3c/dc:title%3e %3c/cc:Work%3e %3c/rdf:RDF%3e %3c/metadata%3e %3cg transform='translate(-110.96345%2c-120.11396)' id='layer1' inkscape:groupmode='layer' inkscape:label='Layer 1'%3e %3cpath d='m 111.08855%2c120.23831 1.4612%2c1.47002 -1.4612%2c1.47003' style='fill:none%3bstroke:white%3bstroke-width:0.352777%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-miterlimit:10%3bstroke-dasharray:none%3bstroke-opacity:1' id='path632' /%3e %3c/g%3e%3c/svg%3e";

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Pagination = /*#__PURE__*/function (_Component) {
  _inherits(Pagination, _Component);

  var _super = _createSuper$5(Pagination);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _super.apply(this, arguments);
  }

  _createClass(Pagination, [{
    key: "paginate",
    value: function paginate(page) {
      console.log('paginate');
      var page_size = this.props.post.page_size || 6;
      this.props.fetchPosts(page_size, page, this.props.filter);

      if (this.props.scrollRef) {
        window.scrollTo({
          behavior: 'smooth',
          top: this.props.scrollRef.current.offsetTop
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.paginationContainerStyle || {},
        className: this.props.paginationContainerClass ? "pagination-container ".concat(this.props.paginationContainerClass) : 'pagination-container'
      }, this.props.total_pages > 1 ? /*#__PURE__*/React.createElement("div", {
        style: this.props.paginationStyle || {},
        className: this.props.paginationClass ? "pagination ".concat(this.props.paginationClass) : 'pagination'
      }, /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "indicators",
        onClick: function onClick() {
          _this.paginate(_this.props.page - 1);
        },
        disabled: this.props.page <= 0
      }, /*#__PURE__*/React.createElement("img", {
        src: img$1,
        alt: "previous page",
        style: {
          marginRight: '3px'
        }
      }))), this.props.page > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, !this.props.hideNumber ? /*#__PURE__*/React.createElement("p", null, this.props.page + 1 - 1) : /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          _this.paginate(_this.props.page - 1);
        },
        className: "post-marker"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "item"
      }), /*#__PURE__*/React.createElement("div", {
        className: "item active"
      }, !this.props.hideNumber ? /*#__PURE__*/React.createElement("p", null, this.props.page + 1) : /*#__PURE__*/React.createElement("span", {
        className: "post-marker"
      })), this.props.page < this.props.total_pages - 1 ? /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, !this.props.hideNumber ? /*#__PURE__*/React.createElement("p", null, this.props.page + 1 + 1) : /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          _this.paginate(_this.props.page + 1);
        },
        className: "post-marker"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "item"
      }), /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "indicators",
        onClick: function onClick() {
          _this.paginate(_this.props.page + 1);
        },
        disabled: this.props.page >= this.props.total_pages - 1
      }, /*#__PURE__*/React.createElement("img", {
        src: img,
        alt: "previous page",
        style: {
          marginLeft: '3px'
        }
      })))) : '');
    }
  }]);

  return Pagination;
}(Component);

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BlogFilters$1 = /*#__PURE__*/function (_Component) {
  _inherits(BlogFilters, _Component);

  var _super = _createSuper$4(BlogFilters);

  function BlogFilters(props) {
    var _this;

    _classCallCheck(this, BlogFilters);

    _this = _super.call(this, props);
    _this.onFilter = _this.onFilter.bind(_assertThisInitialized(_this));
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BlogFilters, [{
    key: "onFilter",
    value: function onFilter(filter) {
      console.log("Filter Posts - ".concat(filter));
      this.props.setFilter(filter);
      this.props.fetchPosts('', '', filter);
    }
  }, {
    key: "onSelect",
    value: function onSelect(e) {
      console.log("Filter Posts - ".concat(e.target.value));
      var topic = e.target.value;
      this.onFilter(topic);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var filterList = [];
      var filterOptions = [];

      if (this.props.filters && this.props.filters.length > 0) {
        filterList = this.props.filters.map(function (filter, index) {
          return /*#__PURE__*/React.createElement("li", {
            key: "filter_list_".concat(index),
            className: _this2.props.filter === filter.value ? 'active' : '',
            onClick: function onClick() {
              return _this2.onFilter(filter.value);
            }
          }, filter.displayValue);
        });
        filterOptions = this.props.filters.map(function (filter, index) {
          return /*#__PURE__*/React.createElement("option", {
            key: "filter_option_".concat(index),
            value: filter.value
          }, filter.displayValue);
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "filters"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "drop-dwn"
      }, /*#__PURE__*/React.createElement("li", {
        className: this.props.filter === '' ? 'active' : '',
        onClick: function onClick() {
          return _this2.onFilter('');
        }
      }, "All Posts"), filterList), /*#__PURE__*/React.createElement("select", {
        className: "select-drop-dwn",
        onChange: this.onSelect,
        defaultValue: ""
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "All Posts"), filterOptions));
    }
  }]);

  return BlogFilters;
}(Component);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BlogFilters = /*#__PURE__*/function (_Component) {
  _inherits(BlogFilters, _Component);

  var _super = _createSuper$3(BlogFilters);

  function BlogFilters(props) {
    var _this;

    _classCallCheck(this, BlogFilters);

    _this = _super.call(this, props);
    _this.onFilter = _this.onFilter.bind(_assertThisInitialized(_this));
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BlogFilters, [{
    key: "onFilter",
    value: function onFilter(filter) {
      console.log("Filter Posts - ".concat(filter, " (onFilter)"));
      this.props.setFilter(filter);
      this.props.fetchPosts('', '', filter);
    }
  }, {
    key: "onSelect",
    value: function onSelect(e) {
      console.log("Filter Posts - ".concat(e.target.value, " (onSelect)"));
      var topic = e.target.value;
      this.onFilter(topic);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var filterOptions = [];

      if (this.props.filters && this.props.filters.length > 0) {
        this.props.filters.map(function (filter, index) {
          return /*#__PURE__*/React.createElement("li", {
            key: "filter_list_".concat(index),
            className: _this2.props.filter === filter.value ? 'active' : '',
            onClick: function onClick() {
              return _this2.onFilter(filter.value);
            }
          }, filter.displayValue);
        });
        filterOptions = this.props.filters.map(function (filter, index) {
          return /*#__PURE__*/React.createElement("option", {
            key: "filter_option_".concat(index),
            value: filter.value
          }, filter.displayValue);
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "filters"
      }, /*#__PURE__*/React.createElement("select", {
        className: "select-main",
        onChange: this.onSelect,
        name: "category",
        defaultValue: ''
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "CATEGORY"), filterOptions));
    }
  }]);

  return BlogFilters;
}(Component);

var Select_form = function Select_form(props) {
  var handleSubmit = props.handleSubmit,
      onSubmit = props.onSubmit,
      label = props.label,
      submitting = props.submitting,
      tags = props.tags;
  var tagOptions = [];

  if (tags && tags.length > 0) {
    tagOptions = tags.map(function (tag, index) {
      return /*#__PURE__*/React.createElement("option", {
        key: "tag_option_".concat(index),
        value: tag
      }, tag);
    });
  }

  return /*#__PURE__*/React.createElement("form", {
    className: "filterSelect-form",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(Field, {
    name: "tag",
    type: "text",
    component: dgSelect,
    containerClass: "field-group filter-select",
    label: label ? label : ""
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "All Posts"), tagOptions), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: submitting,
    className: "btn-primary"
  }, "Filter"));
};

Select_form = reduxForm({
  form: 'Dg_Blogs_Select_form'
})(Select_form);
var Selectform = Select_form;

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FiltersNew = /*#__PURE__*/function (_Component) {
  _inherits(FiltersNew, _Component);

  var _super = _createSuper$2(FiltersNew);

  function FiltersNew(props) {
    var _this;

    _classCallCheck(this, FiltersNew);

    _this = _super.call(this, props);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.getFilterDisplay = _this.getFilterDisplay.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FiltersNew, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getAllTags();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(data) {
      var query = this.props.post.filter || {};
      this.props.post.page || 0;
      var page_size = this.props.post.page_size || 6;
      console.log(data);
      console.log(this.props.post);

      if (data && data.tag && data.tag !== undefined) {
        query.tag = data.tag;
        this.props.setFilter(query);
      }

      if (data.tag === '' || data.tag === ' ' || data.tag === undefined) {
        delete query.tag;
        this.props.setFilter(query);
      }

      console.log('query: ', query);
      this.props.fetchPosts(page_size, 0, query)["catch"](function (res) {
        Swal.fire('Error', res.message, 'error');
      });
    }
  }, {
    key: "getFilterDisplay",
    value: function getFilterDisplay(displayType) {
      var _this2 = this;

      var type = displayType.toUpperCase();

      switch (type) {
        case 'DROPDOWN':
          return /*#__PURE__*/React.createElement(Selectform, {
            onSubmit: this.onSubmit,
            tags: this.props.tags,
            label: this.props.label,
            enableReinitialize: true
          });

        case 'LIST':
          var tagOptions = [];

          if (this.props.tags && this.props.tags.length > 0) {
            tagOptions = this.props.tags.map(function (tag, index) {
              return /*#__PURE__*/React.createElement("div", {
                key: "option_".concat(index)
              }, /*#__PURE__*/React.createElement("li", {
                key: "tag_option_".concat(index),
                onClick: function onClick() {
                  return _this2.onSubmit({
                    tag: tag
                  });
                },
                className: _this2.props.filter && _this2.props.filter.tag === tag ? 'active' : '',
                value: tag // className={
                //   Object.values(this.props.filter).indexOf(tag) > -1
                //     ? 'active'
                //     : ''
                // }

              }, tag));
            });
          }

          return /*#__PURE__*/React.createElement("div", {
            className: "tag-container"
          }, /*#__PURE__*/React.createElement("div", {
            className: "tag-wrapper-desktop"
          }, /*#__PURE__*/React.createElement("div", {
            className: "tags"
          }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
            className: this.props.filter && (this.props.filter.tag === undefined || this.props.filter.tag === '') ? 'active' : '',
            onClick: function onClick() {
              return _this2.onSubmit({
                tag: ''
              });
            }
          }, "All Posts"), tagOptions))), /*#__PURE__*/React.createElement("div", {
            className: "tag-wrapper-mobile"
          }, /*#__PURE__*/React.createElement(Selectform, {
            onSubmit: this.onSubmit,
            tags: this.props.tags,
            enableReinitialize: true
          })));

        default:
          return /*#__PURE__*/React.createElement(Selectform, {
            onSubmit: this.onSubmit,
            tags: this.props.tags,
            enableReinitialize: true
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "filters"
      }, this.getFilterDisplay(this.props.filterDisplay));
    }
  }]);

  return FiltersNew;
}(Component);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FiltersLeft = /*#__PURE__*/function (_Component) {
  _inherits(FiltersLeft, _Component);

  var _super = _createSuper$1(FiltersLeft);

  function FiltersLeft(props) {
    var _this;

    _classCallCheck(this, FiltersLeft);

    _this = _super.call(this, props);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.getFilterDisplay = _this.getFilterDisplay.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FiltersLeft, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getAllTags();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(data) {
      var query = this.props.post.filter || {};
      this.props.post.page || 0;
      var page_size = this.props.post.page_size || 6;
      console.log(data);
      console.log(this.props.post);

      if (data && data.tag && data.tag !== undefined) {
        query.tag = data.tag;
        this.props.setFilter(query);
      }

      if (data.tag === "" || data.tag === " " || data.tag === undefined) {
        delete query.tag;
        this.props.setFilter(query);
      }

      console.log("query: ", query);
      this.props.fetchPosts(page_size, 0, query)["catch"](function (res) {
        Swal.fire("Error", res.message, "error");
      });
    }
  }, {
    key: "getFilterDisplay",
    value: function getFilterDisplay(displayType) {
      var _this2 = this;

      var type = displayType.toUpperCase();

      switch (type) {
        case "DROPDOWN":
          return /*#__PURE__*/React.createElement(Selectform, {
            onSubmit: this.onSubmit,
            tags: this.props.tags,
            label: this.props.label,
            enableReinitialize: true
          });

        case "LIST":
          var tagOptions = [];

          if (this.props.tags && this.props.tags.length > 0) {
            tagOptions = this.props.tags.map(function (tag, index) {
              return /*#__PURE__*/React.createElement("div", {
                key: "option_".concat(index)
              }, /*#__PURE__*/React.createElement("li", {
                key: "tag_option_".concat(index),
                onClick: function onClick() {
                  return _this2.onSubmit({
                    tag: tag
                  });
                },
                className: _this2.props.filter && _this2.props.filter.tag === tag ? "active" : "",
                value: tag
              }, tag));
            });
          }

          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "tag-wrapper-desktop"
          }, /*#__PURE__*/React.createElement("div", {
            className: "tags"
          }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
            className: this.props.filter && (this.props.filter.tag === undefined || this.props.filter.tag === "") ? "active" : "",
            onClick: function onClick() {
              return _this2.onSubmit({
                tag: ""
              });
            }
          }, "All Posts"), tagOptions))), /*#__PURE__*/React.createElement("div", {
            className: "tag-wrapper-mobile"
          }, /*#__PURE__*/React.createElement(Selectform, {
            onSubmit: this.onSubmit,
            tags: this.props.tags,
            enableReinitialize: true
          })));

        default:
          return /*#__PURE__*/React.createElement(Selectform, {
            onSubmit: this.onSubmit,
            tags: this.props.tags,
            enableReinitialize: true
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "filters-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "filters"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("h4", null, "FILTER")), /*#__PURE__*/React.createElement("div", {
        className: "tag-container"
      }, this.getFilterDisplay(this.props.filterDisplay))));
    }
  }]);

  return FiltersLeft;
}(Component);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Blogs = /*#__PURE__*/function (_Component) {
  _inherits(Blogs, _Component);

  var _super = _createSuper(Blogs);

  function Blogs(props) {
    var _this;

    _classCallCheck(this, Blogs);

    _this = _super.call(this, props);
    _this.scrollRef = /*#__PURE__*/React.createRef();
    _this.getFilter = _this.getFilter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Blogs, [{
    key: "getFilter",
    value: function getFilter(filterType) {
      var type = filterType.toUpperCase();

      switch (type) {
        case "LEFT":
          return /*#__PURE__*/React.createElement(FiltersLeft, {
            getAllTags: this.props.getAllTags,
            filterDisplay: this.props.filterDisplay,
            tags: this.props.tags,
            label: this.props.filterLabel,
            filter: this.props.filter,
            post: this.props.post,
            setFilter: this.props.setFilter,
            fetchPosts: this.props.fetchPosts
          });

        case "ALT":
          return /*#__PURE__*/React.createElement(BlogFilters, {
            filters: this.props.filters,
            filter: this.props.filter,
            setFilter: this.props.setFilter,
            fetchPosts: this.props.fetchPosts,
            createSearch: this.props.createSearch
          });

        case "NEW":
          return /*#__PURE__*/React.createElement(FiltersNew, {
            getAllTags: this.props.getAllTags,
            filterDisplay: this.props.filterDisplay,
            tags: this.props.tags,
            label: this.props.filterLabel,
            filter: this.props.filter,
            post: this.props.post,
            setFilter: this.props.setFilter,
            fetchPosts: this.props.fetchPosts
          });

        default:
          return /*#__PURE__*/React.createElement(BlogFilters$1, {
            filters: this.props.filters,
            filter: this.props.filter,
            setFilter: this.props.setFilter,
            fetchPosts: this.props.fetchPosts
          });
      }
    }
  }, {
    key: "getCards",
    value: function getCards(cardType, index, post) {
      var type = typeof cardType === "string" ? cardType.toUpperCase() : cardType;

      switch (type) {
        case "GLASS":
          return /*#__PURE__*/React.createElement(BlogCard, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "COVERINACLICK":
          return /*#__PURE__*/React.createElement(CardCoverInAClick, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "swing":
        case "Swing":
        case "SWING":
          return /*#__PURE__*/React.createElement(CardHorizontal, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "horizontal":
        case "Horizontal":
        case "HORIZONTAL":
          return /*#__PURE__*/React.createElement(CardHorizontal$1, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "alt":
        case "Alt":
        case "ALT":
          return /*#__PURE__*/React.createElement(CardAlt, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            showDate: this.props.showDate,
            showSummary: this.props.showSummary,
            showTags: this.props.showTags,
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "small":
        case "Small":
        case "SMALL":
          return /*#__PURE__*/React.createElement(CardAltSmall, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            linkText: this.props.linkText,
            imageTint: this.props.imageTint,
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "alt2":
        case "ALT2":
          return /*#__PURE__*/React.createElement(CardAlt2, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            linkText: this.props.linkText,
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {}
          });

        case "default":
        case "Default":
        case "DEFAULT":
          return /*#__PURE__*/React.createElement(Card, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {},
            truncateNumWords: this.props.truncateNumWords
          });

        default:
          return /*#__PURE__*/React.createElement(Card, {
            key: "Blog_Card_".concat(index),
            post: post,
            style: this.props.postStyle || {},
            cardClass: this.props.postClass || "",
            onSelect: this.props.postOnSelect ? this.props.postOnSelect : function (post) {},
            truncateNumWords: this.props.truncateNumWords
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var posts = [];

      if (this.props.posts && this.props.posts.length > 0) {
        posts = this.props.posts.map(function (post, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: "post__".concat(index),
            className: _this2.props.containerMiddleClass ? _this2.props.containerMiddleClass : ""
          }, _this2.getCards(_this2.props.cardType, index, post));
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.containerStyle ? this.props.containerStyle : {},
        className: this.props.containerClass ? "react-blogs-container ".concat(this.props.containerClass) : "react-blogs-container"
      }, this.props.displayFeaturedPost ? /*#__PURE__*/React.createElement(FeaturedPost, {
        post: this.props.featuredPost,
        style: this.props.featuredPostStyle || {},
        cardClass: this.props.featuredPostClass || "",
        onSelect: this.props.featuredPostOnSelect ? this.props.featuredPostOnSelect : function () {}
      }) : "", this.props.filterType ? this.getFilter(this.props.filterType) : "", this.props.post && this.props.post.items && this.props.post.items.length > 0 ? /*#__PURE__*/React.createElement("div", {
        ref: this.scrollRef,
        style: this.props.postsContainerStyle,
        className: this.props.postsContainerClass ? "posts-container ".concat(this.props.postsContainerClass) : "posts-container"
      }, posts) : /*#__PURE__*/React.createElement("div", {
        style: this.props.postsContainerStyle,
        className: this.props.postsContainerClass ? "posts-container ".concat(this.props.postsContainerClass) : "posts-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "no-posts-container"
      }, /*#__PURE__*/React.createElement("h2", null, "We're sorry"), /*#__PURE__*/React.createElement("p", null, "There doesn't seem to be any blog posts available at the moment"))), this.props.posts && this.props.posts.length > 0 ? /*#__PURE__*/React.createElement(Pagination, {
        paginationContainerStyle: {},
        paginationContainerClass: "",
        paginationStyle: {},
        paginationClass: "",
        filter: this.props.filter,
        fetchPosts: this.props.fetchPosts,
        hideNumber: this.props.hideNumber,
        scrollRef: this.scrollRef,
        post: this.props.post,
        total_pages: this.props.total_pages,
        page: this.props.page
      }) : "");
    }
  }]);

  return Blogs;
}(Component);

export { Blogs as B, Card as C, FeaturedPost as F, Pagination as P, CardAlt as a, CardHorizontal$1 as b, CardHorizontal as c };
